import { TeilnehmerVO } from "@core/api/v1";
import BerufEnum = TeilnehmerVO.BerufEnum;

export const berufOptionen: { label: string, value: BerufEnum }[] = [
    {label: 'Arzt', value: BerufEnum.ARZT },
    {label: 'Dipl. Pflegefachkraft', value: BerufEnum.PFLEGER },
    {label: 'Psycholog*in', value: BerufEnum.PSYCHOLOGE },
];
